import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { ApiError, apiGet } from '../api/client.js';

interface AuthState {
  ready: boolean;
  isAuthed: boolean;
}

const AuthCtx = createContext<AuthState>({ ready: false, isAuthed: false });

export function AuthProvider({ children }: { children: ReactNode }): JSX.Element {
  const [state, setState] = useState<AuthState>({ ready: false, isAuthed: false });
  useEffect(() => {
    apiGet('/api/stores')
      .then(() => setState({ ready: true, isAuthed: true }))
      .catch((e) =>
        setState({
          ready: true,
          isAuthed: !(e instanceof ApiError && e.status === 401),
        }),
      );
  }, []);
  return <AuthCtx.Provider value={state}>{children}</AuthCtx.Provider>;
}

export const useAuth = (): AuthState => useContext(AuthCtx);
